<template>
  <div> 

   <card class="col-sm-12 text-center mt-5" >
          procesando respuesta ...
    </card>
  </div>
</template>
<script>

import auth from '../service/auth'   
import { Loading } from "element-ui"


  export default {

    mounted()
    {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        })

        const  currUrl = window.location.href
        console.log('mounted oauth currUrl', currUrl);
        auth.auth.parseCognitoWebResponse(currUrl)
    },
    data () {
      return {
  
        
      }
    }
  }
</script> 
